import React, { useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import moment from "moment";
import Modal from "modal-react-native-web";
import { authActionLogin } from "../action/authAction";
import { useRecoilState, useRecoilValue } from "recoil";
import { tokenState, userState } from "../reducer/recoil";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { apiservice } from "../service";

const { width, height } = Dimensions.get("window");
export default function newsInfo({
  User,
  showDetail,
  onPress,
  condition,
  navigation,
  route,
}) {
  const [remember, setRemember] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);
  const user = useRecoilValue(userState);
  const [status, setStatus] = useState();
  const [conditions, setCondition] = useState();
  const [getEvents, setgetEvents] = useState();

  const [state, setState] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const refUser = useRef();
  const refPass = useRef();
  async function Login() {
    if (state.username.length > 0 && state.password.length > 0) {
      const login = await authActionLogin(state);
      setToken(login);
      if (login) {
        setModalVisible(false);
        navigation.navigate("Condition");
      }
      if (!login) {
        setStatus(login);
      }
      refUser.current.clear();
      refPass.current.clear();
    }
  }
  const [data, setData] = useState([
    "100 meter",
    "200 meter",
    "4x400 meter",
    "Triple Jump",
    "Pole Vault",
    "400 meter",
    "800 meter",
    "4x100 meter",
    "High Jump",
    "Decathon",
    "1500 meter",
    "5000 meter",
    "Shot Put",
    "Long Jump",
    "Discus Throw",
    "100m Hurdles",
    "400m Hurdles",
    "Jevelin Throw",
    "Mixed Relay",
    "3000m Steplechase",
  ]);
  function closeModal() {
    setModalVisible(false);
    onPress();
  }
  async function Register() {
    if (token.user !== undefined && token.user.role == "User") {
      navigation.navigate("Condition", route.params);
    }
    if (token == "") {
      setModalVisible(true);
    }
  }

  let prelim =
    new Date(route.params.prelim_start_date).getTime() <=
      new Date().getTime() &&
    new Date(route.params.prelim_end_date).getTime() >= new Date().getTime();

  let final = false;

  try {
    Associationdata.map((items, idexs) => {
      let itemArr = items.Approbations.filter((i) => {
        return item.competition_id == i.competition_id;
      })[0];
      prelim =
        itemArr.approbation_status == "Pending" &&
        itemArr.approbation_type == "Prelim";
      final =
        new Date(item.final_start_date).getTime() <= new Date().getTime() &&
        new Date(item.final_end_date).getTime() >= new Date().getTime() &&
        itemArr.approbation_status == "Approved" &&
        itemArr.approbation_type == "Prelim";
      final =
        (itemArr.approbation_status !== "Approved" &&
          itemArr.approbation_type == "Final") ||
        (itemArr.approbation_status !== "Pending" &&
          itemArr.approbation_type == "Prelim");

      console.log("itemArr", index, itemArr);
    });
  } catch (error) {}

  async function callApi() {
    try {
      // const competition_id = route.params.competition_id;
      // const acceptance = await apiservice({
      //   method: "get",
      //   path:
      //     "/approbations/condition-acceptance?competition_id=" +
      //     competition_id +
      //     "&association_id=" +
      //     user.profile.Association.association_id,
      //   token: token.token,
      // });

      // console.log("acceptance ", acceptance);

      // if (acceptance.status == 200) {
      //   setCondition(acceptance.data.result);
      // }

      const resp = await apiservice({
        path: "/competitions/opt/events",
        method: "get",
      });

      if (resp.status == 200) {
        console.log("/opt/events", resp.data.getEvents);
        setgetEvents(resp.data.getEvents);
      }
    } catch (error) {}
  }

  useEffect(() => {
    callApi();
  }, []);

  if (getEvents == undefined) {
    return <View />;
  }

  return (
    <View>
      {showDetail && (
        <Modal
          animationType="fade"
          transparent={true}
          visible={modalVisible}
          onRequestClose={() => {
            Alert.alert("Modal has been closed.");
            setModalVisible(!modalVisible);
          }}
        >
          <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
            <View style={[styles.viewLogo]}>
              <Image
                resizeMode={"contain"}
                source={require("../img/logo4.png")}
                style={
                  (width < 1280 && stylesResponsive.imgLogo) ||
                  (width < 1600 && styles1280.imgLogo) ||
                  (width >= 1600 && styles.imgLogo)
                }
              />
              <Text
                style={
                  (width < 1280 && stylesResponsive.textTitle) ||
                  styles.textTitle
                }
              >
                {route.params.name}
              </Text>
            </View>
            <View
              style={
                (width < 1280 && stylesResponsive.viewLogin) || styles.viewLogin
              }
            >
              <TextInput
                ref={refUser}
                onChangeText={(text) => setState({ ...state, username: text })}
                placeholder="Username or E-mail"
                style={[
                  width < 1280
                    ? stylesResponsive.InputLogin
                    : styles.InputLogin,
                  { borderWidth: status == false ? 1 : 0, borderColor: "red" },
                ]}
              />
              <TextInput
                ref={refPass}
                onChangeText={(text) => setState({ ...state, password: text })}
                secureTextEntry
                placeholder="Password"
                source
                style={[
                  width < 1280
                    ? stylesResponsive.InputLogin
                    : styles.InputLogin,
                  { borderWidth: status == false ? 1 : 0, borderColor: "red" },
                ]}
              />
              {status == false && (
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: "Prompt",
                    color: "red",
                    marginHorizontal: 45,
                  }}
                >
                  Please enter a valid email or password.
                </Text>
              )}
              <TouchableOpacity
                onPress={() => {
                  setRemember((val) => !val);
                }}
                style={styles.buttonRemember}
              >
                <View
                  style={[
                    styles.viewRemember,
                    { backgroundColor: remember ? "#2B6AB1" : "#FFFFFF" },
                  ]}
                />
                <Text style={styles.textRemember}>Remember me</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={Login}
                style={
                  width >= 1280
                    ? styles.buttonLogin
                    : stylesResponsive.buttonLogin
                }
              >
                <Text style={styles.textLogin}>LOGIN</Text>
              </TouchableOpacity>
              <Text style={styles.TextForgotPassword}>
                {"Forgot your password ?\nPlease contact AAA Service"}
              </Text>
              <TouchableOpacity
                style={{ marginTop: 10, alignSelf: "center" }}
                onPress={() => {
                  setModalVisible(!modalVisible);
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: "Prompt",
                    color: "#2B6AB1",
                  }}
                >
                  Login later
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
      )}
      {condition && (
        <Image
          resizeMode={"contain"}
          style={
            (width < 1280 && stylesResponsive.imgTitle) ||
            (width < 1600 && styles1280.imgTitle) ||
            (width >= 1600 && styles.imgTitle)
          }
          source={{ uri: route.params.image_url }}
        />
      )}
      <View style={styles.viewDetail}>
        {condition && (
          <View style={{ width: "100%" }}>
            <Text
              style={
                (width < 1280 && stylesResponsive.textSubject) ||
                (width < 1600 && styles1280.textSubject) ||
                styles.textSubject
              }
            >
              CONDITION
            </Text>
            <Text
              style={
                (width < 1280 && stylesResponsive.textCondition) ||
                (width < 1600 && styles1280.textCondition) ||
                styles.textCondition
              }
            >
              {ReactHtmlParser(route.params.description)}
            </Text>
          </View>
        )}
        {showDetail && (
          <View style={{}}>
            <Text
              style={
                (width < 1280 && stylesResponsive.textSubject) ||
                (width < 1600 && styles1280.textSubject) ||
                styles.textSubject
              }
            >
              EVENTS
            </Text>
            <View style={width >= 1600 && styles.viewEvent}>
              <View
                style={{
                  marginBottom: width >= 1600 ? height * 0.1 : 20,
                }}
              >
                <Text
                  style={
                    (width < 1280 && stylesResponsive.textGenderEvent) ||
                    (width < 1600 && styles1280.textGenderEvent) ||
                    styles.textGenderEvent
                  }
                >
                  MALE
                </Text>
                <FlatList
                  data={route.params.events_male.filter((item) => {
                    if (
                      getEvents.filter(
                        (e) => e.event_name == item && e.event_gender == "Male"
                      ).length > 0
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  })}
                  numColumns={width < 1280 ? 2 : 5}
                  renderItem={({ index, item }) => {
                    return (
                      <Text
                        numberOfLines={1}
                        style={
                          (width < 1280 && stylesResponsive.textItemEvent) ||
                          (width < 1600 && styles1280.textItemEvent) ||
                          styles.textItemEvent
                        }
                      >
                        {item}
                      </Text>
                    );
                  }}
                />
                <View>
                  <Text
                    style={
                      (width < 1280 && stylesResponsive.textGenderEvent) ||
                      (width < 1600 && styles1280.textGenderEvent) ||
                      styles.textGenderEvent
                    }
                  >
                    FEMALE
                  </Text>
                  <FlatList
                    data={route.params.events_female.filter((item) => {
                      if (
                        getEvents.filter(
                          (e) =>
                            e.event_name == item && e.event_gender == "Female"
                        ).length > 0
                      ) {
                        return true;
                      } else {
                        return false;
                      }
                    })}
                    numColumns={width < 1280 ? 2 : 5}
                    renderItem={({ index, item }) => {
                      return (
                        <Text
                          numberOfLines={1}
                          style={
                            (width < 1280 && stylesResponsive.textItemEvent) ||
                            (width < 1600 && styles1280.textItemEvent) ||
                            styles.textItemEvent
                          }
                        >
                          {item}
                        </Text>
                      );
                    }}
                  />
                </View>
              </View>
              {width >= 1600 && (
                <View style={{ marginLeft: 40 }}>
                  <Text style={styles.textDate}>PRELIM. DATE</Text>
                  <Text style={styles.textTime}>
                    {moment(route.params.prelim_start_date)
                      .utcOffset("+0000")
                      .format("DD/MM/YYYY (HH:mm)")}{" "}
                    -{" "}
                    {moment(route.params.prelim_end_date)
                      .utcOffset("+0000")
                      .format("DD/MM/YYYY (HH:mm)") +
                      ` (GMT${moment(route.params.prelim_end_date).format(
                        "Zz"
                      )})`}
                  </Text>
                  <Text style={styles.textDate}>FINAL. DATE</Text>
                  <Text style={styles.textTime}>
                    {moment(route.params.final_start_date)
                      .utcOffset("+0000")
                      .format("DD/MM/YYYY (HH:mm)")}{" "}
                    -{" "}
                    {moment(route.params.final_end_date)
                      .utcOffset("+0000")
                      .format("DD/MM/YYYY (HH:mm)") +
                      ` (GMT${moment(route.params.final_end_date).format(
                        "Zz"
                      )})`}
                  </Text>
                  <TouchableOpacity
                    onPress={Register}
                    disabled={
                      new Date(route.params.prelim_start_date).getTime() <=
                        new Date().getTime() &&
                      new Date(route.params.prelim_end_date).getTime() >=
                        new Date().getTime()
                        ? false
                        : true
                    }
                    style={[
                      styles.buttonRegister,
                      {
                        backgroundColor:
                          new Date(route.params.prelim_start_date).getTime() <=
                            new Date().getTime() &&
                          new Date(route.params.prelim_end_date).getTime() >=
                            new Date().getTime()
                            ? "#2B6AB1"
                            : "#E6EEF8",
                      },
                    ]}
                  >
                    <Text style={styles.textRegister}>REGISTER</Text>
                  </TouchableOpacity>
                </View>
              )}
            </View>
            {width < 1600 && (
              <View>
                <Text
                  style={
                    (width < 1280 && stylesResponsive.textDate) ||
                    (width < 1600 && styles1280.textDate) ||
                    styles.textDate
                  }
                >
                  PRELIM. DATE
                </Text>
                <Text
                  style={
                    (width < 1280 && stylesResponsive.textTime) ||
                    (width < 1600 && styles1280.textTime) ||
                    styles.textTime
                  }
                >
                  {moment(route.params.prelim_start_date)
                    .utcOffset("+0000")
                    .format("DD/MM/YYYY (HH:mm)")}{" "}
                  -{" "}
                  {moment(route.params.prelim_end_date)
                    .utcOffset("+0000")
                    .format("DD/MM/YYYY (HH:mm)") +
                    ` (GMT${moment(route.params.prelim_end_date).format(
                      "Zz"
                    )})`}
                </Text>
                <Text
                  style={
                    (width < 1280 && stylesResponsive.textDate) ||
                    (width < 1600 && styles1280.textDate) ||
                    styles.textDate
                  }
                >
                  FINAL. DATE
                </Text>
                <Text
                  style={
                    (width < 1280 && stylesResponsive.textTime) ||
                    (width < 1600 && styles1280.textTime) ||
                    styles.textTime
                  }
                >
                  {moment(route.params.final_start_date)
                    .utcOffset("+0000")
                    .format("DD/MM/YYYY (HH:mm)")}{" "}
                  -{" "}
                  {moment(route.params.final_end_date)
                    .utcOffset("+0000")
                    .format("DD/MM/YYYY (HH:mm)") +
                    ` (GMT${moment(route.params.final_end_date).format("Zz")})`}
                </Text>
                {token.user !== undefined && token.user.role == "User" && (
                  <>
                    {new Date(route.params.prelim_start_date).getTime() <=
                      new Date().getTime() &&
                      new Date(route.params.prelim_end_date).getTime() >=
                        new Date().getTime() && (
                        <TouchableOpacity
                          onPress={Register}
                          disabled={
                            route.params.prelim_status === "Open" && !conditions
                              ? false
                              : true
                          }
                          style={[
                            (width < 1280 && stylesResponsive.buttonRegister) ||
                              styles.buttonRegister,
                            {
                              backgroundColor:
                                route.params.prelim_status === "Open" &&
                                !conditions
                                  ? "#2B6AB1"
                                  : "#E6EEF8",
                            },
                          ]}
                        >
                          <Text
                            style={
                              (width < 1280 && stylesResponsive.textRegister) ||
                              styles.textRegister
                            }
                          >
                            REGISTER
                          </Text>
                        </TouchableOpacity>
                      )}
                  </>
                )}
              </View>
            )}
          </View>
        )}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  imgTitle: {
    width: "50%",
    maxHeight: 451,
    height: "60%",
    alignSelf: "center",
    marginVertical: 40,
  },
  viewDetail: {
    marginVertical: 20,
    marginHorizontal: width * 0.1,
  },
  textSubject: {
    fontSize: 28,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  viewEvent: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textGenderEvent: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textItemEvent: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    width: width * 0.08,
  },
  textTime: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDate: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonRegister: {
    width: 201,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    marginTop: 25,
  },
  textRegister: {
    fontSize: 25,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  viewLogo: {
    marginTop: 100,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  imgLogo: {
    width: 145,
    height: 139,
    marginHorizontal: 10,
  },
  textTitle: {
    fontSize: 30,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    textAlign: "center",
  },
  viewLogin: {
    width: 461,
    height: 473,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    marginTop: 53,
    paddingVertical: 20,
  },
  InputLogin: {
    width: 367,
    height: 70,
    borderRadius: 8,
    backgroundColor: "#D0E3F9",
    color: "#717171",
    fontFamily: "Prompt",
    paddingHorizontal: 22,
    alignSelf: "center",
    marginTop: 30,
  },
  buttonRemember: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 47,
    marginTop: 30,
  },
  viewRemember: {
    width: 22,
    height: 23,
    borderWidth: 1,
    borderColor: "#707070",
    borderRadius: 7,
  },
  textRemember: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#717171",
    marginLeft: 10,
  },
  buttonLogin: {
    width: 279,
    height: 56,
    backgroundColor: "#173B64",
    borderWidth: 1,
    borderColor: "#173B64",
    justifyContent: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 30,
  },
  textLogin: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  TextForgotPassword: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#717171",
    textAlign: "center",
    marginTop: 5,
  },
  textCondition: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 11,
  },
});
const styles1280 = StyleSheet.create({
  imgLogo: {
    width: 145,
    height: 139,
    marginHorizontal: 10,
  },
  imgTitle: {
    width: "50%",
    height: 350,
    alignSelf: "center",
    marginVertical: 40,
  },
  textSubject: {
    fontSize: 24,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textCondition: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 11,
  },
  textGenderEvent: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textItemEvent: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    width: width * 0.3,
  },
  textDate: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textTime: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
});
const stylesResponsive = StyleSheet.create({
  imgLogo: {
    width: 106,
    height: 100,
    marginHorizontal: 10,
  },
  imgTitle: {
    width: width * 0.8,
    height: 200,
    alignSelf: "center",
    marginVertical: 40,
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    textAlign: "center",
  },
  textSubject: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textCondition: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 11,
  },
  textGenderEvent: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textItemEvent: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    width: width * 0.4,
  },
  textDate: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textTime: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonRegister: {
    width: 150,
    height: 40,
    borderRadius: 28,
    justifyContent: "center",
    marginTop: 25,
  },
  textRegister: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  viewLogin: {
    width: width * 0.8,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    marginTop: 30,
    paddingVertical: 20,
  },
  InputLogin: {
    width: width * 0.7,
    height: 50,
    borderRadius: 8,
    backgroundColor: "#D0E3F9",
    fontSize: 12,
    color: "#717171",
    fontFamily: "Prompt",
    paddingHorizontal: 22,
    alignSelf: "center",
    marginTop: 30,
  },
  buttonLogin: {
    width: width * 0.7,
    height: 56,
    backgroundColor: "#173B64",
    borderWidth: 1,
    borderColor: "#173B64",
    justifyContent: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 30,
  },
});
